<template>
<v-dialog v-model="uiStore.errorDialogOpen" max-width="480">
    <v-card>
        <v-card-title class="d-flex align-center">
            <v-icon icon="$error" color="error" class="mr-2" />
            {{ title }}
        </v-card-title>

        <v-card-text style="white-space: pre-line;">
            {{ message }}
        </v-card-text>

        <v-card-actions>
            <v-spacer />

            <v-btn color="primary" variant="text" @click="uiStore.closeErrorDialog()">
                Close
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useUIStore } from '@/stores/ui'
import { getGoogleErrorMessage, getGoogleErrorTitle, GoogleError } from '@/utils/googleError'

const uiStore = useUIStore()

const title = computed(() => {
    const err = uiStore.currentError
    return err instanceof GoogleError ? getGoogleErrorTitle(err) : 'Something went wrong'
})

const message = computed(() => {
    const err = uiStore.currentError
    if (err instanceof GoogleError) {
        return getGoogleErrorMessage(err)
    }

    return err instanceof Error ? err.message : 'An unexpected error occurred.'
})
</script>
